import Select from "react-select";
import styled from "@emotion/styled";

export default function Selector(props) {

  const StyledSelect = styled(Select)`
  .css-1hb7zxy-IndicatorsContainer {
    height: 29px !important;
    display: flex;
    justify-content: flex-end;
  }
  .css-1dimb5e-singleValue {
    height: 32px !important;
    display: flex;
    align-items: center;
  }
  input:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: transparent !important;
  }
`;

  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: props.backgroundColor || "#E8EBEF",
      textColor: props.textColor || "#263445",
      borderColor: state.isFocused ? "#8D97A4" : "#E8EBEF",
      border: state.isFocused ? "2px solid #0287EF" : "",
      height: 32,
      minHeight: 32,

      padding: "0",
      boxShadow: state.isFocused ? null : null,
      alignItems: "baseline"
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: "33px",
      padding: "0 6px",
    }),
  };

  return (
    <div>
      {props.label && (
        <div className="flex items-center text-sm  mb-1">
          <label className="block text-contrast-70 whitespace-nowrap cursor-default">
            {props.label}
          </label>
          {props.definition && (
            <p className="block text-contrast-70 text-darkblue-400 whitespace-nowrap ml-1">
              ({props.definition})
            </p>
          )}
          {props.required && <p className="block text-contrast-70">*</p>}
        </div>
      )}
      <div className="text-sm rounded-md mr-2 w-full">
        <StyledSelect
          isDisabled={props.isDisabled}
          styles={customStyles}
          menuPlacement={props.placement || "bottom"}
          placeholder={props.placeholder}
          className={props.className + "  text-left"}
          options={props.options}
          onChange={props.onChange}
          defaultValue={props.defaultValue}
          // value={props.value}
          isSearchable={props.isSearchable ? true : false}
          isClearable={props.isClearable == true ? true : false}
        />
      </div>

      {props.labelHelper && (
        <p className="mt-2 text-2xs text-contrast-70">{props.labelHelper}</p>
      )}
      {props.error && (
        <p className="mt-2 text-base error-text">{props.error}</p>
      )}
      {props.successText && (
        <p className="mt-2 text-base success-text">{props.successText}</p>
      )}
    </div>
  );
}
